import tr from './tr.json'
import en from './en.json'

export default defineI18nConfig(() => {
  const raw = useCookie('locale').value || (import.meta.env.VITE_DEFAULT_LOCALE as string)
  const normalize = (v?: string) => (v ? v.split('-')[0] : 'tr')
  const locale = normalize(raw) as 'tr' | 'en'

  return {
    legacy: false,
    locale,
    fallbackLocale: 'tr',
    messages: {
      en,
      tr,
      'en-US': en,
      'tr-TR': tr,
    },
    warnHtmlMessage: false,
    missingWarn: false,
    fallbackWarn: false,
  }
})
